import img1 from "./img1.jpg";
import img2 from "./img2.jpg";
import img3 from "./img3.jpg";
import img4 from "./img4.jpg";
import img5 from "./img5.jpg";

const data = {
  cardData: [
    {
      id: 1,
      img: img1,
      title: "iphone 14",
      desc: "128gb -₹69,999 , 256gb - ₹78,999,  256gb - ₹99,999"
    },
    {
      id: 2,
      img: img2,
      title: "ipad 10 Generation",
      desc: "64gb - ₹41,999 , 256gb - ₹57,900"
    },
    {
      id: 3,
      img: img3,
      title: "MacBook",
      desc: "₹99,900.00"
    },
    {
      id: 4,
      img: img4,
      title: "iwatch series-7",
      desc: "₹41,700"
    },
    {
      id: 5,
      img: img5,
      title: "Airpods 2nd Generation",
      desc: "₹14,999"
    }
  ]
};
export default data;
